/**
 * MSP organization identity (own M365/GWorkspace tenant) — gated by LaunchDarkly
 * `msp-org-identity` (and camelCase / bracket variants commonly returned by `useFlags()`).
 */
export function isMspOrgIdentityLdEnabled(flags: Record<string, unknown> | undefined): boolean {
  if (!flags || typeof flags !== "object") {
    return false;
  }
  const f = flags as Record<string, unknown>;
  return f.mspOrgIdentity === true || f.msporgidentity === true || f["msp-org-identity"] === true;
}
